import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerContactModalComponent } from './historical-customer-contact-modal.component';
import { HistoricalCustomerContactComponent } from './historical-customer-contact.component';

@NgModule({
    declarations: [
        HistoricalCustomerContactComponent,
        HistoricalCustomerContactModalComponent
    ],
    providers: [
    ],
    imports: [
        CommonModule,
        CalendarModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerContactComponent,
        HistoricalCustomerContactModalComponent
    ]
})

export class HistoricalCustomerContactModule { }
